import { render, staticRenderFns } from "./SliderView.vue?vue&type=template&id=2aa3b97c&scoped=true&"
import script from "./SliderView.vue?vue&type=script&lang=js&"
export * from "./SliderView.vue?vue&type=script&lang=js&"
import style0 from "./SliderView.vue?vue&type=style&index=0&id=2aa3b97c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa3b97c",
  null
  
)

export default component.exports